<template>
  <div class="card">
    <div class="card-header">
      <h2>Settings & Features</h2>
    </div>
    <div class="card-body">
      <div class="form-grid">
        <div class="form-field">
          <label for="position_day">Position (Day)</label>
          <input 
            id="position_day"
            :value="modelValue.position_day"
            @input="updateField('position_day', $event.target.value)"
            type="number"
            min="0"
            placeholder="Enter day position"
          >
        </div>
        
        <div class="form-field">
          <label for="position_night">Position (Night)</label>
          <input 
            id="position_night"
            :value="modelValue.position_night"
            @input="updateField('position_night', $event.target.value)"
            type="number"
            min="0"
            placeholder="Enter night position"
          >
        </div>
      
        <div class="form-field">
          <label for="sleep_id">Sleep ID</label>
          <input 
            id="sleep_id"
            :value="modelValue.sleep_id"
            @input="updateField('sleep_id', $event.target.value)"
            type="text"
            placeholder="Enter sleep ID (optional)"
          >
        </div>
        
        <div class="form-field">
          <label for="related_field">Related Assessment Option ID</label>
          <input 
            id="related_field"
            :value="modelValue.related_field"
            @input="updateField('related_field', $event.target.value)"
            type="text"
            placeholder="Enter related option ID (optional)"
          >
        </div>
      </div>

      <div class="checkbox-grid">
        <label class="checkbox-field">
          <input 
            type="checkbox" 
            id="is_premium" 
            :checked="modelValue.is_premium"
            @change="updateField('is_premium', $event.target.checked)"
          >
          <span class="checkbox-label">Premium Course</span>
        </label>
        
        <label class="checkbox-field">
          <input 
            type="checkbox" 
            id="top_course" 
            :checked="modelValue.top_course"
            @change="updateField('top_course', $event.target.checked)"
          >
          <span class="checkbox-label">Top Course</span>
        </label>
        
        <label class="checkbox-field">
          <input 
            type="checkbox" 
            id="is_breathing" 
            :checked="modelValue.is_breathing"
            @change="updateField('is_breathing', $event.target.checked)"
          >
          <span class="checkbox-label">Breathing Exercise</span>
        </label>
        
        <label class="checkbox-field">
          <input 
            type="checkbox" 
            id="is_sleeping" 
            :checked="modelValue.is_sleeping"
            @change="updateField('is_sleeping', $event.target.checked)"
          >
          <span class="checkbox-label">Sleep Feature</span>
        </label>
        
        <label class="checkbox-field">
          <input 
            type="checkbox" 
            id="is_active" 
            :checked="modelValue.is_active"
            @change="updateField('is_active', $event.target.checked)"
          >
          <span class="checkbox-label">Is Active</span>
        </label>
        
        <label class="checkbox-field">
          <input 
            type="checkbox" 
            id="preview_status" 
            :checked="modelValue.preview_status"
            @change="updateField('preview_status', $event.target.checked)"
          >
          <span class="checkbox-label">Preview Enabled</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SettingsFeaturesCard',
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  emits: ['update:modelValue'],
  methods: {
    updateField(field, value) {
      this.$emit('update:modelValue', {
        ...this.modelValue,
        [field]: value
      });
    }
  }
};
</script>

<style scoped>
.card {
  background-color: white;
  border-radius: 0.75rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: box-shadow 0.2s ease;
}

.card:hover {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07);
}

.card-header {
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #e2e8f0;
}

.card-header h2 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
}

.card-body {
  padding: 1.5rem;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
}

.form-field {
  display: flex;
  flex-direction: column;
}

.form-field label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #4b5563;
  margin-bottom: 0.5rem;
}

.form-field input {
  height: 2.75rem;
  padding: 0 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  background-color: white;
  font-size: 0.875rem;
  color: #1e293b;
  transition: all 0.2s ease;
}

.form-field input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
}

.form-field input:hover {
  border-color: #9ca3af;
}

.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
  margin-top: 1.5rem;
}

.checkbox-field {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.checkbox-field input[type="checkbox"] {
  height: 1rem;
  width: 1rem;
  margin-right: 0.75rem;
  accent-color: #3b82f6;
}

.checkbox-label {
  font-size: 0.875rem;
  color: #4b5563;
}
</style> 